import { getNodeString, Value } from '@udecode/plate-common';

export const getDescriptionFromRichTextArea = (value: Value) => {
  return value?.map(n => getNodeString(n)).join(' ');
};

export const isRichTextAreaEmpty = (value: Value) => {
  const textString = getDescriptionFromRichTextArea(value);

  return textString.trim().length === 0;
};
